package one.healthium.db

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import kotlin.Unit
import one.healthium.db.database.newInstance
import one.healthium.db.database.schema

public interface AppDatabase : SuspendingTransacter {
  public val dailyTasksQueries: DailyTasksQueries

  public val foodQueries: FoodQueries

  public val savedContentQueries: SavedContentQueries

  public val shoppingListDataQueries: ShoppingListDataQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = AppDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): AppDatabase = AppDatabase::class.newInstance(driver)
  }
}
